import { ComingSoon, type MenuItem } from '@felix/ui';
import { useTranslation } from 'react-i18next';
import { Shell } from '../components/Shell.js';

/** Henüz yapılmamış modül (ADR 0019 §3): menüde görünür, tasarlanmış "hazırlanıyor" sayfası. */
export function ComingSoonPage({ item, group }: { item: MenuItem; group?: MenuItem }) {
  const { t } = useTranslation();
  return (
    <Shell title={t(`menu.${item.id}`)}>
      <ComingSoon item={item} {...(group?.icon ? { icon: group.icon } : {})} />
    </Shell>
  );
}
